import { TBlueObj } from "@app/types/insider";

export const ieTreeItemsClient = "Client";
export const ieTreeItemsSerialNo = "SerialNo";
export const ieTreeItemsCalculation = "Calculation";
export const ieTreeItemsItems = "Items";
export const ieTreeItemsDetails = "Details";

export type TUIInvoiceEditing = {
  currentTreeItemid: string;
};

export const uiInvoiceEditing: TBlueObj<TUIInvoiceEditing> = {
  name: "uiInvoiceEditing",
  initialState: {
    currentTreeItemid: ieTreeItemsClient,
  },
  starfx: true,
  idb: false,
  bootPriority: 0,
};
//constituents of the invoice

export const ieTreeItems = [
  {
    id: ieTreeItemsClient,
    parent: null,
    title: "Client",
  },
  {
    id: ieTreeItemsSerialNo,
    parent: null,
    title: "SerialNo",
  },
  {
    id: ieTreeItemsCalculation,
    parent: null,
    title: "Calculation",
  },
  {
    id: ieTreeItemsItems,
    parent: null,
    title: "Items",
  },
  {
    id: ieTreeItemsDetails,
    parent: null,
    title: "Details",
  },
];
